import React from "react";
import styles from "./EmailInput.module.scss";
import block from 'bem-css-modules';

import { sanitizeContent as s } from "../../../../util/functions";
import { UseFormRegister, FieldErrors } from "react-hook-form";
import { IFieldProperties } from "../InputFields.types";

const EmailInput = (props: { fieldData: IFieldProperties, register: UseFormRegister<any>, errors: FieldErrors }) => {
  const {
    fieldData: {
      text,
      label,
      title,
      placeholder,
      validationText,
      settings: [{
        crmProperty,
        required,
        validation
      }]
    },
    register,
    errors
  } = props;

  const b = block(styles);

  function isValidEmail(email: string): boolean {
    // Use a regular expression to check if the email is in a valid format
    const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  }

  const handleEmailValidation = (value: string) => {
    if (value === "") return true;
    return validation ? isValidEmail(value) : true;
  }

  return (
    <div className={`email-field ${b()}`}>
      {title && (
        <h3 className={b("title")} dangerouslySetInnerHTML={{ __html: s(title) }}/>
      )}
      {text && <div className={`email-field-text ${b("text")}`} dangerouslySetInnerHTML={{ __html: s(text) }} />}
      <input
        id={label}
        data-crm-field={crmProperty}
        placeholder={placeholder}
        type="email"
        {...register(
          label,
          {
            validate: handleEmailValidation,
            required: required
          }
        )}
      />
      {errors[label] && (
        <div className={b("error")} dangerouslySetInnerHTML={{ __html: s(validationText) }} />
      )}
    </div>
  )
}

export default EmailInput;